"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.licenseAllowsGCM = exports.licenseAllowsFailover = exports.licenseAllowsEdgeAI = exports.licenseAllowUpdate = exports.isSourceOrPlaylistAllowedInPerpetualMode = exports.isSourceAllowedInPerpetualMode = exports.isLicenseInPerpetualMode = exports.isInsetAllowedInPerpetualMode = exports.isAppAllowedInPerpetualMode = exports.hasValidLicense = exports.hasLicense = exports.getUControlCUUsage = exports.getTensorCUUsage = exports.getSourceCUUsage = exports.getResolutionCUFactor = exports.getLicensedGPUs = exports.getGPUCUUsage = exports.getFrameRateCUFactor = exports.getEdgeCUUsage = exports.getCUUsage = exports.getCPUCUUsage = exports.getAllowedCU = exports.EMPTY_LICENSE_CU_USAGE_DATA = void 0;
var _common = require("../common");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// don't touch license

var hasLicense = exports.hasLicense = function hasLicense(license) {
  return license && license.issueDate > 0;
};

// check license is installed and not expired
var hasValidLicense = exports.hasValidLicense = function hasValidLicense(license) {
  if (!hasLicense(license)) {
    return false;
  }
  if (license.licenseTerm === "PERPETUAL") {
    // perpetual license doesn't expire
    return true;
  }
  return license.expiryDate > Date.now() || license.allowPerpetualMode;
};

// "perpetual mode" is a new 12.10 feature where valid license automatically changes into an restricted mode after expiration
var isLicenseInPerpetualMode = exports.isLicenseInPerpetualMode = function isLicenseInPerpetualMode(license) {
  if (!hasLicense(license)) {
    return false;
  }
  if (license.licenseTerm === "PERPETUAL") {
    return false;
  }
  if (license.expiryDate > Date.now()) {
    return false;
  }
  return license.allowPerpetualMode;
};
var FREE_APPS = [_common.APP_IDS.Calibration, _common.APP_IDS.Config, _common.APP_IDS.SDK];
var isAppAllowedInPerpetualMode = exports.isAppAllowedInPerpetualMode = function isAppAllowedInPerpetualMode(appID, license) {
  if (!isLicenseInPerpetualMode(license)) {
    return true;
  }
  if (!appID || FREE_APPS.includes(appID)) {
    return true;
  }
  if (!license.perpetualModeApps || license.perpetualModeApps.length < 1) {
    return true;
  }
  if (appID === _common.APP_IDS.GCM) {
    return false;
  }
  return license.perpetualModeApps.includes(appID);
};
var isSourceAllowedInPerpetualMode = exports.isSourceAllowedInPerpetualMode = function isSourceAllowedInPerpetualMode(sourceSpec, license) {
  if (!isLicenseInPerpetualMode(license)) {
    return true;
  }
  if (!license.perpetualModeSources || license.perpetualModeSources.length < 1) {
    return true;
  }
  return license.perpetualModeSources.includes(sourceSpec);
};
var isSourceOrPlaylistAllowedInPerpetualMode = exports.isSourceOrPlaylistAllowedInPerpetualMode = function isSourceOrPlaylistAllowedInPerpetualMode(item, license) {
  if (!item) {
    return true;
  }
  if (item.params) {
    return isSourceAllowedInPerpetualMode(item.type.value, license);
  }
  var playlist = item;
  var notAllowedItemIndex = playlist.items.findIndex(function (i) {
    var _i$sourceDef;
    return !isSourceAllowedInPerpetualMode((_i$sourceDef = i.sourceDef) === null || _i$sourceDef === void 0 ? void 0 : _i$sourceDef.type.value, license);
  });
  return notAllowedItemIndex < 0;
};
var isInsetAllowedInPerpetualMode = exports.isInsetAllowedInPerpetualMode = function isInsetAllowedInPerpetualMode(inset, license) {
  if (!inset) {
    return true;
  }
  var notAllowedItemIndex = inset.playList.items.findIndex(function (i) {
    var _i$source;
    return !isSourceAllowedInPerpetualMode((_i$source = i.source) === null || _i$source === void 0 ? void 0 : _i$source.type.value, license);
  });
  return notAllowedItemIndex < 0;
};
var gpuModelMatch = function gpuModelMatch(gpu, modelName) {
  if (!modelName) {
    return false;
  }
  return gpu.gpuData.model.toLowerCase() === modelName.trim().toLowerCase();
};
var getLicensedGPUs = exports.getLicensedGPUs = function getLicensedGPUs(license, gpus) {
  if (!hasLicense(license)) {
    return gpus;
  }
  if (!license.licenseTier.supportedGPUs || license.licenseTier.supportedGPUs.length < 1) {
    return gpus;
  }
  return gpus.filter(function (item) {
    return license.licenseTier.supportedGPUs.findIndex(function (model) {
      return gpuModelMatch(item, model);
    }) >= 0;
  });
};
var licenseAllowsFailover = exports.licenseAllowsFailover = function licenseAllowsFailover(license) {
  if (!license || !hasValidLicense(license)) {
    return false;
  }
  if (isLicenseInPerpetualMode(license)) {
    return false;
  }
  return license.licenseTier.failover;
};
var licenseAllowsGCM = exports.licenseAllowsGCM = function licenseAllowsGCM(license) {
  if (!license || !hasValidLicense(license)) {
    return false;
  }
  if (isLicenseInPerpetualMode(license)) {
    return false;
  }
  return license.gcm && license.gcmExpiry >= Date.now();
};
var licenseAllowsEdgeAI = exports.licenseAllowsEdgeAI = function licenseAllowsEdgeAI(license) {
  if (!license || !hasValidLicense(license)) {
    return false;
  }
  if (isLicenseInPerpetualMode(license)) {
    return false;
  }
  return license.edgeAI && license.edgeAIExpiry >= Date.now();
};
var licenseAllowUpdate = exports.licenseAllowUpdate = function licenseAllowUpdate(license) {
  if (!license || !hasValidLicense(license)) {
    return false;
  }
  if (isLicenseInPerpetualMode(license)) {
    return false;
  }
  return license.supportTier && license.supportExpiry >= Date.now();
};
var CU_1080P = 1.0;
var CU_4K = 4.0;
var CU_8K = 8.0;
var getResolutionCUFactor = exports.getResolutionCUFactor = function getResolutionCUFactor(resolution) {
  var totalPixels = resolution.height * resolution.width;
  if (totalPixels <= 1920 * 1080) {
    return CU_1080P;
  } else if (totalPixels <= 3840 * 2160) {
    return CU_4K;
  } else {
    return CU_8K;
  }
};
var BASE_CU_FRAMERATE = 30;
var getFrameRateCUFactor = exports.getFrameRateCUFactor = function getFrameRateCUFactor(frameRate) {
  return Math.ceil(frameRate.frames / BASE_CU_FRAMERATE);
};
var getSourceCUUsage = exports.getSourceCUUsage = function getSourceCUUsage(sourceUsage) {
  return getResolutionCUFactor(sourceUsage.resolution) * getFrameRateCUFactor(sourceUsage.frameRate);
};
var UCLIENT_CU_FACTOR = 264;
var UCONTROL_CU_FACTOR = 20;
var TENSOR_CORE_FACTOR = 310;
var EMPTY_LICENSE_CU_USAGE_DATA = exports.EMPTY_LICENSE_CU_USAGE_DATA = {
  cudaCoresUsed: 0,
  cpuCores: 0,
  tensorCoresUsed: 0,
  edgeAIEnabled: false,
  sourceUsages: [],
  uclients: 0,
  roomBars: 0,
  ucontrolTablets: 0,
  edgeAIRequests: 0
};
var getCUUsage = exports.getCUUsage = function getCUUsage(data, license) {
  var tensorUsage = 0;
  if (!licenseAllowsEdgeAI(license)) {
    tensorUsage = getTensorCUUsage(data);
  } else {
    if ((license === null || license === void 0 ? void 0 : license.edgeAICU) > 0) {
      tensorUsage = Math.max(getTensorCUUsage(data) - license.edgeAICU, 0);
    } else {
      tensorUsage = 0;
    }
  }
  return getGPUCUUsage(data) + getCPUCUUsage(data) + getEdgeCUUsage(data) + getUControlCUUsage(data) + tensorUsage;
};
var getAllowedCU = exports.getAllowedCU = function getAllowedCU(data, license) {
  if (!license || !data) {
    return 0;
  }
  return license.licenseTier.cu;
};
var getGPUCUUsage = exports.getGPUCUUsage = function getGPUCUUsage(data) {
  if (!data) {
    return 0;
  }
  return data.cudaCoresUsed;
};
var getCPUCUUsage = exports.getCPUCUUsage = function getCPUCUUsage(data) {
  if (!data) {
    return 0;
  }
  var totalSourcesUsage = 0.0;
  var _iterator = _createForOfIteratorHelper(data.sourceUsages),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var sourceUsage = _step.value;
      totalSourcesUsage += getSourceCUUsage(sourceUsage);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return Math.ceil(totalSourcesUsage * data.cpuCores);
};
var getEdgeCUUsage = exports.getEdgeCUUsage = function getEdgeCUUsage(data) {
  if (!data) {
    return 0;
  }
  return (data.uclients + data.roomBars) * UCLIENT_CU_FACTOR;
};
var getUControlCUUsage = exports.getUControlCUUsage = function getUControlCUUsage(data) {
  if (!data) {
    return 0;
  }
  return data.ucontrolTablets * UCONTROL_CU_FACTOR;
};
var getTensorCUUsage = exports.getTensorCUUsage = function getTensorCUUsage(data) {
  if (!data) {
    return 0;
  }
  return data.edgeAIEnabled ? data.tensorCoresUsed * TENSOR_CORE_FACTOR : 0;
};